import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs: [string, string][] = [['Hoe ontvang ik het materiaal?', 'Direct na aankoop krijg je toegang tot alle bestanden om te downloaden — geen wachttijd, geen verzending.'], ['Werkt dit ook als ik zelf geen hockeyachtergrond heb?', 'Ja. Hockey Ready is specifiek gemaakt voor trainers zonder technische achtergrond, met heldere stap-voor-stap uitleg bij elke oefening.'], ['Voor welke leeftijden en niveaus is het geschikt?', 'Van 6 tot 16 jaar, verdeeld in drie niveaus: Basis, Ontwikkeling en Prestatie.'], ['Is het lesmateriaal ergens op afgestemd?', 'Ja, op de gangbare terminologie en niveau-indeling van hockeyclubs in Nederland en België.'], ['In welk formaat krijg ik de boeken?', 'Als PDF, klaar om te printen of digitaal te gebruiken op een tablet tijdens de training.'], ['Kan ik het printen of alleen digitaal gebruiken?', 'Beide. Alle materialen zijn zowel printklaar als digitaal bruikbaar.'], ['Is er een geld-terug-garantie?', 'Ja, 30 dagen niet-goed-geld-terug, zonder vragen — en je mag de bonussen houden.']];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-45" data-mp="2fcz1htdcvkgu">
      <Reveal className="mx-auto max-w-3xl" data-id="element-46" data-mp="2ffl5xk4y9juu">
        <div className="mb-12 text-center" data-id="element-47" data-mp="2adm62k8f552n">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-moss" data-id="element-48" data-mp="2ah079p5cj88i">
            GOED OM TE WETEN
          </p>
          <h2 className="text-3xl font-black text-brand-green md:text-4xl" data-id="element-49" data-mp="2jeu36yz77zv5">
            Veelgestelde Vragen
          </h2>
        </div>
        <div className="space-y-3" data-id="element-50" data-mp="u0xms9o4ahnx">
          {faqs.map(([question, answer], index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-green/[0.08] bg-brand-alt" data-id="element-51" data-mp="2p5euc9cs7fof" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold text-brand-green focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange" data-id="element-52" data-mp="2z0owqy73dp2q">
                  <span data-id="element-53" data-mp="3hult99g5e7a7">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-moss" aria-hidden="true" data-id="element-54" data-mp="3mqt2bb3ubywd" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-moss" aria-hidden="true" data-id="element-55" data-mp="3vsshdxvaoswo" />}
                </button>
                <AnimatePresence initial={false} data-id="element-56" data-mp="1f4sz4kpiky59">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-57" data-mp="1b37fmgih5lm3">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-58" data-mp="1u2bif7jfaj5b">
                        {answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}